module.exports = __webpack_public_path__ + "img/njysddlzs.ed627b5d.png";